import { formatToCurrencyType } from "helper/common";
import React from "react";
import { ColumnsEdit } from "types/models/column-table-edit";

const columns: ColumnsEdit = [
  {
    title: "Mã",
    dataIndex: "maDichVu",
    key: "maDichVu",
    // render: (text, record, index) => index + 1,
    // width: "4%",
    align: "center"
  },
  {
    title: "Tên dịch vụ",
    dataIndex: "tenDichVu",
    key: "tenDichVu",
    // width: "18%",
  },
  {
    title: "Giá trị",
    dataIndex: "giaTri",
    key: "giaTri",
    align: "right",
    render : (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>
    }
    // width: "18%",
  },
  {
    title: "Số lần ban đầu",
    dataIndex: "soLanBanDau",
    key: "soLanBanDau",
    // width: "5%",
    align: "right",
  },
  {
    title: "Số lần đã dùng",
    dataIndex: "soLanSuDung",
    key: "soLanSuDung",
    // width: "5%",
    align: "right",
  },
  
];

export { columns };
